<template>
  <div class="hyjy">
    <div class="hy-title">行业经验</div>
    <div class="hyjy-content">
      <img src="@/assets/images/hyjy.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Hyjy",
};
</script>
<style lang="less">
.hyjy {
  margin-top: 70px;
  .hyjy-content {
    margin: 50px 114px 0;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
